import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit-icon, app-edit-icon-button',
  templateUrl: './app-edit-icon-button.component.html',
  styleUrls: ['./app-edit-icon-button.component.scss'],
})
export class AppEditIconButtonComponent {
  @Input() disabled: boolean = false;
  @Input() title: string = 'Edit';
  @Input() customClass: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() stopPropagation: boolean = true;
  @Output() btnClick = new EventEmitter<MouseEvent>();
  @Output() click = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (this.stopPropagation) {
      event.stopPropagation();
    }
    this.btnClick.emit(event);
    this.click.emit(event);
  }
}

